import { z } from "zod";

export const inviteUserSchema = z.object({
  email: z.string().email(),
  fullName: z.string().min(1),
  isSupplier: z.boolean(),
  roleIds: z.array(z.number().int()).min(1),
  vendorIds: z.array(z.number().int()).optional(),
  plantIds: z.array(z.number().int()).optional(),
});
export type InviteUserInput = z.infer<typeof inviteUserSchema>;

export const unlockUserSchema = z.object({ userId: z.number().int() });

export const assignRoleSchema = z.object({
  userId: z.number().int(),
  roleIds: z.array(z.number().int()),
});
